var React = require('react');

function RightArrow (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"Union_17","data-name":"Union 17","d":"M24.649,35.316,36.388,23.577H0V16.79H36.639L24.649,4.8l4.8-4.8L49.5,20.056l-.1.1h0L29.448,40.115Z","fill":"#ffffff","stroke":"#000000"}));
}

RightArrow.defaultProps = {"width":"50","height":"44","viewBox":"1 -1 47 44"};

module.exports = RightArrow;

RightArrow.default = RightArrow;
